import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import axios from '../../store/axios-secure'
import { set } from 'date-fns'
// import Logo from "../assets/logo.svg";
import { FaCircle } from 'react-icons/fa'
import Badge from '@mui/material/Badge'
import { FaExclamation, FaFilter, FaChevronDown } from 'react-icons/fa' //?
import { BsChatText } from 'react-icons/bs'
import Loader from '../Common/Loader'
import { FaEyeSlash } from 'react-icons/fa'
import { IoMdArchive } from 'react-icons/io'
import { MdOutlineUnarchive } from 'react-icons/md'
import { HiOutlineSpeakerphone } from 'react-icons/hi'

export default function Contacts({
    contacts,
    setContacts,
    changeChat,
    clients,
    setShowConts,
    setCurrentChat,
    socket,
    hasUnreadMsg,
    setHasUnreadMsg,
    currentSelected,
    setCurrentSelected,
    totalUnreadMessages,
    setTotalUnreadMessages,
    totalUnreadContacts,
    setTotalUnreadContacts,
    showBroadCastPage,
    setShowBroadCastPage,
    broadcastFilteredClients,
    setBroadcastFilteredClients,
    selectedBrodcastFilter,
    setSelectedBroadcastFilter,
    exceptOrOnlyClients,
    setExceptOrOnlyClients,
}) {
    const [currentUserName, setCurrentUserName] = useState(undefined)
    const [currentUserImage, setCurrentUserImage] = useState(undefined)
    // const [currentSelected, setCurrentSelected] = useState(undefined)
    const Logo =
        'https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/brand/EvolvLogo.png'
    const [searchText, setSearchText] = useState('')
    const [filteredArchContacts, setFilteredArchContacts] = useState(contacts)
    const [filteredClients, setFilteredClients] = useState(clients)
    const [filteredChatLoader, setFilteredChatLoader] = useState(false)
    const [normalChatLoader, setNormalChatLoader] = useState(false)
    const [unreadChatLoader, setUnreadChatLoader] = useState(false)
    const [showArchived, setShowArchived] = useState(false)
    const [rightClickedContact, setRightClickedContact] = useState(null)
    const [handleArchiveLoader, setHandleArchiveLoader] = useState(false)
    const [serchedBroadcastContacts, setSerchedBroadcastContacts] = useState([])

    useEffect(() => {
        let broadContacts = contacts.filter(
            (contact) => contact?.isArchived !== true,
        )
        setBroadcastFilteredClients(broadContacts)
    }, [])

    useEffect(() => {
        setExceptOrOnlyClients([])
    }, [selectedBrodcastFilter])

    const onBroadcastContactClick = (index, contact) => {
        console.log('inside onBroadcastContactClick...', contact)
        // Sort the filteredContacts so that the selected contact comes first

        // const isChoosen = exceptOrOnlyClients.includes(contact?.userRef)
        // setBroadcastFilteredClients((prevContacts) => {
        //     const filtered = prevContacts.filter((c) => c._id !== contact._id)
        //     return isChoosen ? [...filtered, contact] : [contact, ...filtered]
        // })

        setExceptOrOnlyClients((prevClients) => {
            const isSelected = prevClients.includes(contact.userRef)

            if (selectedBrodcastFilter === 'active clients except') {
                // In 'active clients except' mode, add to exceptOrOnlyClients if not already there
                // or remove if already present
                return isSelected
                    ? prevClients.filter((id) => id !== contact.userRef)
                    : [...prevClients, contact.userRef]
            } else if (selectedBrodcastFilter === 'only share with') {
                return isSelected
                    ? prevClients.filter((id) => id !== contact.userRef)
                    : [...prevClients, contact.userRef]
            } else {
                // Default behavior (could be no-op or some other logic)
                return prevClients
            }
        })

        // // Scroll to the top of the contacts container
        // if (contactsContainerRef.current) {
        //   contactsContainerRef.current.scrollTop = 0;
        // }
    }
    // const contactsContainerRef = useRef();
    // const toggleArchive = () => {
    //     event.stopPropagation(); // Prevent event propagation
    //     setShowArchived(!showArchived);
    // };
    useEffect(() => {
        // Filter contacts based on whether they are archived or not
        setFilteredArchContacts(
            contacts.filter((contact) =>
                showArchived ? contact.isArchived : !contact.isArchived,
            ),
        )
    }, [contacts, showArchived])

    const toggleArchive = async (event) => {
        try {
            event.stopPropagation() //prevent the event from reaching the parent container's click event handler
            setShowArchived(!showArchived)
        } catch (error) {
            console.log('error on toggleArchive ', error)
        }
    }

    useEffect(() => {
        const checkUnreadMessages = async () => {
            const totalUnreadMessages = contacts.reduce(
                (accumulator, contact) =>
                    accumulator + (contact?.unreadMessages.length || 0),
                0,
            )
            const totalUnreadContacts = contacts.filter(
                (contact) => contact.unreadMessages.length > 0,
            ).length
            setTotalUnreadContacts(totalUnreadContacts)
            setTotalUnreadMessages(totalUnreadMessages)
            setHasUnreadMsg(totalUnreadMessages > 0)
        }

        checkUnreadMessages()
    }, [contacts])

    const changeCurrentChat = (index, contact) => {
        setSearchText('')
        if (currentSelected) {
            //if cross sign over chat container is clicked then also it leaves the room
            let clientId = currentSelected.userRef.toString()
            let leaveType = 'trainer'
            if (currentSelected._id != contact._id) {
                console.log('emitting room...', clientId)
                socket.emit('leave_room', { clientId, leaveType })
            }
        }

        // console.log('contact changeCurrentChat.........', contact)
        setCurrentSelected(contact)
        let joinerType = 'trainer'
        let clientId = contact?.userRef?.toString()
        console.log('trainer joining room ...', clientId)
        socket.emit('join_room', { clientId, joinerType })
        contact.unreadMessages = [] //it may need to set this inside setContacts
        // contact.messages = contact.messages.map((msg) => {
        //     if (msg && msg?.hasRead == false && msg.senderType !== 'trainer') {
        //         return { ...msg, hasRead: true };
        //     }
        //     return { ...msg };
        // });
        changeChat(contact)
        //setCurrentChat(contact)
        // Sort the filteredContacts so that the selected contact comes first
        // setFilteredContacts((prevContacts) => {
        //   const filtered = prevContacts.filter((c) => c._id !== contact._id);
        //   return [contact, ...filtered];
        // });
        // // Scroll to the top of the contacts container
        // if (contactsContainerRef.current) {
        //   contactsContainerRef.current.scrollTop = 0;
        // }
    }
    // useEffect(async () => {
    //   const fContacts = await contacts.filter((contact) =>
    //     contact.username.toLowerCase().includes(searchText.toLowerCase())
    //   );
    //   console.log("fContacts........//", fContacts)
    //   setFilteredContacts(fContacts)
    // }, [searchText]);
    useEffect(async () => {
        if (
            selectedBrodcastFilter == 'active clients except' ||
            selectedBrodcastFilter == 'only share with'
        ) {
            // console.log(
            //     'searchText&broadcastFilteredClients.....',
            //     searchText,
            //     broadcastFilteredClients,
            // )

            const serchedContacts = await broadcastFilteredClients.filter(
                (contact) =>
                    contact.userName &&
                    contact.userName
                        .toLowerCase()
                        .includes(searchText.toLowerCase()),
            )
            // console.log('serchedContacts.....', serchedContacts)
            setSerchedBroadcastContacts(serchedContacts)
        } else {
            const filteredClients = await clients.filter(
                (client) =>
                    client.name &&
                    client.name
                        .toLowerCase()
                        .includes(searchText.toLowerCase()),
            )
            setFilteredClients(filteredClients)
        }
    }, [searchText])

    const onClientClick = async (client) => {
        try {
            const clientId = client?._id.toString()

            const existingChatIndex = contacts.findIndex(
                (chat) => chat.userRef === clientId,
            )
            if (existingChatIndex === -1) {
                // If the chat doesn't exist, fetch it and add it to contacts
                const response = await axios.get(
                    `/chat/getSetClientChat?clientId=${clientId}`,
                )
                const newChat = response?.data?.chat
                console.log('Newchat........', newChat)
                setContacts([newChat, ...contacts])
                changeCurrentChat(0, newChat)
            } else {
                // you might want to change the current chat to the existing one
                changeCurrentChat(
                    existingChatIndex,
                    contacts[existingChatIndex],
                )
            }
        } catch (error) {
            console.log('error onClientClick ', error)
        }
    }
    const onHeaderClick = async () => {
        try {
            setShowConts(false)
            if (currentSelected) {
                let clientId = currentSelected.userRef.toString()
                let leaveType = 'trainer'
                console.log('emitting room...', clientId)
                socket.emit('leave_room', { clientId, leaveType })
            }
            setCurrentSelected(undefined)
            setCurrentChat(undefined)
            setSelectedBroadcastFilter('my active clients')
            setShowBroadCastPage(false)
        } catch (error) {
            console.log('error onClientClick ', error)
        }
    }
    const onFilterClick = async (event) => {
        try {
            event.stopPropagation() //prevent the event from reaching the parent container's click event handler
            setFilteredChatLoader(true)

            const sortType = 'ignoredChat24Hours'
            const response = await axios.get(
                `/chat/getChatsAndClients?sortType=${sortType}`,
            ) //for chat
            // setChatClients(response.data?.clients)
            setContacts(response.data?.chats)
            setFilteredChatLoader(false)
            // setShowArchived(false);
        } catch (error) {
            console.log('error onFilterClick ', error)
            setFilteredChatLoader(false)
        }
    }
    const onUnreadClick = async (event) => {
        try {
            event.stopPropagation() //prevent the event from reaching the parent container's click event handler
            setUnreadChatLoader(true)
            const sortType = 'unreadMessages'
            const response = await axios.get(
                `/chat/getChatsAndClients?sortType=${sortType}`,
            ) //for chat
            // setChatClients(response.data?.clients)
            setContacts(response.data?.chats)
            setUnreadChatLoader(false)
            // setShowArchived(false);
        } catch (error) {
            console.log('error onFilterClick ', error)
            setUnreadChatLoader(false)
        }
    }
    const onDownClick = async () => {
        try {
            setShowConts(false)
            if (currentSelected) {
                let clientId = currentSelected.userRef.toString()
                let leaveType = 'trainer'
                console.log('emitting room...', clientId)
                socket.emit('leave_room', { clientId, leaveType })
            }
            setCurrentSelected(undefined)
            setCurrentChat(undefined)
        } catch (error) {
            console.log('error onClientClick ', error)
        }
    }
    const onChatIconClick = async (event) => {
        try {
            event.stopPropagation()
            setNormalChatLoader(true)
            // const sortType = 'ignoredChat24Hours'
            const response = await axios.get(`/chat/getChatsAndClients`) //for chat
            // setChatClients(response.data?.clients)
            setContacts(response.data?.chats)
            setNormalChatLoader(false)
        } catch (error) {
            console.log('error onFilterClick ', error)
            setNormalChatLoader(false)
        }
    }

    const handleArchiveChat = async (contact, e) => {
        try {
            e.stopPropagation()
            setHandleArchiveLoader(true)
            const archiveChat = [contact?.userRef?.toString()]
            // Toggle the 'archive' boolean
            const archive = !contact?.isArchived

            console.log('archiveChat, archive.........', archiveChat, archive)

            const res = await axios.post(`users/setChatsArchived`, {
                chatIds: archiveChat,
                archive: archive,
            })
            setHandleArchiveLoader(false)
            // Update the contacts array with the modified contact
            setContacts((prevContacts) => {
                return prevContacts.map((prevContact) => {
                    if (prevContact._id === rightClickedContact._id) {
                        return {
                            ...prevContact,
                            isArchived: archive,
                        }
                    }
                    return prevContact
                })
            })
            setRightClickedContact(null)

            // setArchiveChat([]);
            console.log('res archive... ', res?.data)
        } catch (error) {
            console.log('error archive', error)
        }
    }
    const onBroadcatIconClick = async (e) => {
        try {
            e.stopPropagation()
            // setShowBroadCastPage(!showBroadCastPage);
            setShowBroadCastPage(true)

            if (currentSelected) {
                let clientId = currentSelected.userRef.toString()
                let leaveType = 'trainer'
                console.log('emitting room...', clientId)
                socket.emit('leave_room', { clientId, leaveType })
            }
            setCurrentSelected(undefined)
            setCurrentChat(undefined)
        } catch (error) {
            console.log('error onBroadcatIconClick ', error)
        }
    }

    return (
        <>
            {/* {currentUserImage && currentUserImage && ( */}
            <Container>
                <div className="brand" onClick={onHeaderClick}>
                    {/* <img src={Logo} alt="logo" />
                    <h3 style={{ color: hasUnreadMsg ? '#36f5c7' : '' }}>
                        Chat
                    </h3> */}
                    {/* {normalChatLoader ? (
                        <Loader />
                    ) : (
                        <div className="chat-icon" onClick={onChatIconClick}>
                            {totalUnreadMessages > 0 ? (
                                <Badge
                                    color="error"
                                    sx={{ color: '#36f5c7' }}
                                    badgeContent={totalUnreadMessages}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <BsChatText size={25} />
                                </Badge>
                            ) : (
                                <BsChatText
                                    size={25}
                                    style={{ cursor: 'pointer' }}
                                />
                            )}
                        </div>
                    )} */}

                    <HiOutlineSpeakerphone
                        onClick={(e) => {
                            onBroadcatIconClick(e)
                        }}
                        style={{ cursor: 'pointer' }}
                    />

                    {unreadChatLoader ? (
                        <Loader />
                    ) : (
                        <div className="chat-icon" onClick={onUnreadClick}>
                            {totalUnreadContacts > 0 ? (
                                <Badge
                                    color="error"
                                    sx={{ color: '#36f5c7' }}
                                    badgeContent={totalUnreadContacts}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <FaEyeSlash
                                        onClick={onUnreadClick}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </Badge>
                            ) : (
                                <FaEyeSlash
                                    onClick={onUnreadClick}
                                    style={{ cursor: 'pointer' }}
                                />
                            )}
                        </div>
                        // <FaEyeSlash

                        //     onClick={onUnreadClick}
                        //     style={{ cursor: 'pointer' }}
                        // />
                    )}
                    {filteredChatLoader ? (
                        <Loader />
                    ) : (
                        <FaFilter
                            onClick={onFilterClick}
                            style={{ cursor: 'pointer' }}
                        />
                    )}
                    <IoMdArchive
                        onClick={toggleArchive}
                        style={{
                            color: showArchived ? '#36f5c7' : 'inherit',
                            cursor: 'pointer',
                        }}
                    />

                    {/* 
                    <FaChevronDown
                        onClick={onDownClick}
                        style={{ cursor: 'pointer' }}
                    /> */}
                </div>
                <div className="search-bar">
                    <input
                        className="bar-input"
                        type="text"
                        placeholder="search contact..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                </div>

                {/* <div className="contacts">
          {filteredContacts.map((contact, index) => (
            <div
              key={contact._id}
              className={`contact ${index === currentSelected ? "selected" : ""}`}
              onClick={() => changeCurrentChat(index, contact)}
            >
              <div className="username">
                <h6>{contact.username}</h6>
              </div>
            </div>
          ))}
        </div> */}
                {selectedBrodcastFilter !== 'only share with' &&
                selectedBrodcastFilter !== 'active clients except' ? (
                    <div className="contacts">
                        {searchText.trim().length < 1
                            ? // Render your filtered contacts here
                              filteredArchContacts.map((contact, index) => (
                                  <div
                                      key={contact._id}
                                      className={`contact ${
                                          contact?._id === currentSelected?._id
                                              ? 'selected'
                                              : ''
                                      }`}
                                      onClick={() =>
                                          changeCurrentChat(index, contact)
                                      }
                                      onContextMenu={(e) => {
                                          e.preventDefault() // Prevent the default context menu
                                          if (
                                              !rightClickedContact ||
                                              rightClickedContact._id !=
                                                  contact._id
                                          ) {
                                              setRightClickedContact(contact)
                                          } else {
                                              setRightClickedContact(null)
                                          }
                                      }}
                                  >
                                      <div className="avatar">
                                          <img
                                              src={contact.userPhotoUrl}
                                              //   alt="avatar"
                                          />
                                      </div>

                                      <div className="username1">
                                          {/* <h6> */}
                                          {contact.userName}
                                          <div>
                                              {contact?.ignoredChat && ( //?
                                                  <FaExclamation
                                                      className="exclamation-icon"
                                                      style={{
                                                          color: '#ff2f2f',
                                                          fontSize: '10px',
                                                          // padding: '3px',
                                                          // marginTop: '3px',
                                                      }}
                                                  />
                                              )}
                                          </div>
                                          {/* </h6> */}
                                      </div>
                                      {contact?.unreadMessages?.length > 0 && (
                                          <div
                                              className="unreadmessagescount"
                                              style={{ color: '#36f5c7' }}
                                          >
                                              <Badge
                                                  badgeContent={
                                                      contact.unreadMessages
                                                          .length
                                                  }
                                              />

                                              {/* <h6> */}
                                              {/* {contact.unreadMessages.length} */}
                                              {/* </h6> */}
                                          </div>
                                      )}
                                      {rightClickedContact &&
                                          rightClickedContact?._id ==
                                              contact?._id && (
                                              <div
                                                  className="archive-button"
                                                  onClick={(e) =>
                                                      handleArchiveChat(
                                                          rightClickedContact,
                                                          e,
                                                      )
                                                  }
                                              >
                                                  {/* {rightClickedContact?.isArchived ? 'unArchive' : 'Archive'} */}
                                                  {handleArchiveLoader ? (
                                                      <Loader />
                                                  ) : rightClickedContact?.isArchived ? (
                                                      <MdOutlineUnarchive />
                                                  ) : (
                                                      <IoMdArchive />
                                                  )}
                                              </div>
                                          )}
                                  </div>
                              ))
                            : // Render your regular contacts here
                              filteredClients.map((client, index) => (
                                  <div
                                      key={client._id}
                                      className={`contact`}
                                      onClick={() => onClientClick(client)}
                                  >
                                      <div className="avatar">
                                          <img
                                              src={client.photoUrl}
                                              //   alt="avatar"
                                          />
                                      </div>
                                      <div className="username1">
                                          {client.name}
                                          {/* <h6 >{client.userEmail}</h6> */}
                                      </div>
                                  </div>
                              ))}
                    </div>
                ) : (
                    <div className="contacts">
                        {searchText.trim().length < 1
                            ? broadcastFilteredClients.map((contact, index) => (
                                  <div
                                      key={contact._id}
                                      className="contact"
                                      onClick={() =>
                                          onBroadcastContactClick(
                                              index,
                                              contact,
                                          )
                                      }
                                      // onContextMenu={(e) => {
                                      //     e.preventDefault() // Prevent the default context menu
                                      //     if (
                                      //         !rightClickedContact ||
                                      //         rightClickedContact._id != contact._id
                                      //     ) {
                                      //         setRightClickedContact(contact)
                                      //     } else {
                                      //         setRightClickedContact(null)
                                      //     }
                                      // }}
                                  >
                                      <div className="avatar">
                                          <img
                                              src={contact.userPhotoUrl}
                                              //   alt="avatar"
                                          />
                                      </div>

                                      <div className="username1">
                                          {contact.userName}
                                      </div>
                                      <FaCircle
                                          className="circle-icon"
                                          style={{
                                              marginLeft: 'auto',
                                              color:
                                                  selectedBrodcastFilter ===
                                                  'active clients except'
                                                      ? exceptOrOnlyClients.includes(
                                                            contact.userRef,
                                                        )
                                                          ? null
                                                          : '#36f5c7'
                                                      : exceptOrOnlyClients.includes(
                                                            contact.userRef,
                                                        )
                                                      ? '#36f5c7'
                                                      : null,
                                          }}
                                      />
                                  </div>
                              ))
                            : serchedBroadcastContacts.map((contact, index) => (
                                  <div
                                      key={contact._id}
                                      className="contact"
                                      onClick={() =>
                                          onBroadcastContactClick(
                                              index,
                                              contact,
                                          )
                                      }
                                  >
                                      <div className="avatar">
                                          <img
                                              src={contact.userPhotoUrl}
                                              //   alt="avatar"
                                          />
                                      </div>

                                      <div className="username1">
                                          {contact.userName}
                                      </div>
                                      <FaCircle
                                          className="circle-icon"
                                          style={{
                                              marginLeft: 'auto',
                                              color:
                                                  selectedBrodcastFilter ===
                                                  'active clients except'
                                                      ? exceptOrOnlyClients.includes(
                                                            contact.userRef,
                                                        )
                                                          ? null
                                                          : '#36f5c7'
                                                      : exceptOrOnlyClients.includes(
                                                            contact.userRef,
                                                        )
                                                      ? '#36f5c7'
                                                      : null,
                                          }}
                                      />
                                  </div>
                              ))}
                    </div>
                )}
                {/* <div className="current-user">
                        <div className="avatar">
                            <img
                                src={`data:image/svg+xml;base64,${currentUserImage}`}
                                alt="avatar"
                            />
                        </div>
                        <div className="username">
                            <h2>{currentUserName}</h2>
                        </div>
                    </div> */}
            </Container>
            {/* )} */}
        </>
    )
}
const Container = styled.div`
    // display: grid;
    // grid-template-rows: 10% 10% 80%;
    overflow: hidden;
    background-color: #101317;
    .brand {
        display: flex;
        align-items: center;
        gap: 2rem;
        margin: 9px;
        justify-content: center;
        height: 2rem;
        chat-icon {
            height: 1.5rem;
            cursor: pointer;
        }
        img {
            height: 2rem;
        }
        h3 {
            color: white;
            text-transform: uppercase;
            margin-top: 5px;
        }
    }
    .search-bar {
        .bar-input {
            width: 89%;
            margin-left: 5%;
        }
        margin-bottom: 5px;
    }
    .contacts {
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        gap: 0.4rem;
        height: 63vh;
        &::-webkit-scrollbar {
            width: 0.2rem;
            &-thumb {
                background-color: #ffffff39;
                width: 0.1rem;
                border-radius: 1rem;
            }
        }
        .contact {
            background-color: #1f2731;
            min-height: 3.5rem;
            cursor: pointer;
            width: 90%;
            border-radius: 0.2rem;
            padding: 0.4rem;
            display: flex;
            gap: 0.7rem;
            align-items: center;
            transition: 0.5s ease-in-out;
            .avatar {
                img {
                    border-radius: 50px;
                    height: 2rem;
                }
            }
            .username1 {
                display: flex;
                font-size: smaller;
                h6 {
                    color: white;
                }
            }
            .circle-icon {
                color: #101317;
                border: 1px solid #4b4848;
                border-radius: 50px;
            }
        }
        .selected {
            background-color: #323538;
        }
    }

    .current-user {
        background-color: #0d0d30;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        .avatar {
            img {
                border-radius: 50px;
                height: 4rem;
                max-inline-size: 100%;
            }
        }
        .username {
            h2 {
                color: white;
                margin-bottom: 0;
            }
        }
        @media screen and (min-width: 720px) and (max-width: 1080px) {
            gap: 0.5rem;
            .username {
                h2 {
                    font-size: 1rem;
                }
            }
        }
    }
`
